module.exports = ".register {\n    position: fixed;\n    padding-top: 60px;\n    width: 100%;\n    height: 100%;\n    margin: auto auto 50px auto;\n    background-color: #fff;\n    overflow: auto;\n}\n\n.register .container {\n    max-width: 710px;\n}\n\n.terms_and_conditions {\n    font-family: monospace, monospace;\n    font-size: 11px;\n    background-color: #f8e287;\n    padding: 30px;\n    text-align: justify;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.css
// module id = ./src/app/register/register.component.css
// module chunks = main